import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPlayCircle = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPlayCircle",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m426-330 195-125q14-9 14-25t-14-25L426-630q-15-10-30-1t-16 26v250q0 18 16 27t30-2m54 250q-83 0-156-31t-127-86-85-127-32-156 32-156 85-127 127-85 156-32 156 32 127 85 86 127 31 156-31 156-86 127-127 86-156 31m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
  })
}));